import React from 'react';
import PropTypes from 'prop-types';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Navigation, Pagination, A11y, Autoplay, EffectFade} from 'swiper';
import Page from '../../Page/Page';

import SecondImage from '../../../assets/annete-banner-normal-2.webp';
import ThirdImage from '../../../assets/annete-banner-normal-3.webp';
import FourthImage from '../../../assets/annete-banner-normal-4.webp';
import FifthImage from '../../../assets/annete-banner-normal-5.webp';
import SixthImage from '../../../assets/annete-banner-normal-6.webp';
import SeventhImage from '../../../assets/annete-banner-normal-7.webp';
import EighthImage from '../../../assets/annete-banner-normal-8.webp';
import NinthImage from '../../../assets/annete-banner-normal-9.webp';

import SecondImageFull from '../../../assets/annete-banner-full-2.webp';
import ThirdImageFull from '../../../assets/annete-banner-full-3.webp';
import FourthImageFull from '../../../assets/annete-banner-full-4.webp';
import FifthImageFull from '../../../assets/annete-banner-full-5.webp';
import SixthImageFull from '../../../assets/annete-banner-full-6.webp';
import SeventhImageFull from '../../../assets/annete-banner-full-7.webp';
import EighthImageFull from '../../../assets/annete-banner-full-8.webp';
import NinthImageFull from '../../../assets/annete-banner-full-9.webp';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';

const slideStyle = {display: 'flex', justifyContent: 'center'};

// Served from public/ (not webpack-processed) so their URLs match the
// <link rel="preload"> tags in public/index.html exactly.
const FirstImage = `${process.env.PUBLIC_URL}/annete-banner-normal-1.webp`;
const FirstImageFull = `${process.env.PUBLIC_URL}/annete-banner-full-1.webp`;

const WebviewCarousel = ({fullScreen}) => {
  const normalImages = [
    FirstImage, SecondImage, ThirdImage, FourthImage, FifthImage,
    SixthImage, SeventhImage, EighthImage, NinthImage,
  ];
  const fullImages = [
    FirstImageFull, SecondImageFull, ThirdImageFull,
    FourthImageFull, FifthImageFull, SixthImageFull,
    SeventhImageFull, EighthImageFull, NinthImageFull,
  ];
  const images = fullScreen ? fullImages : normalImages;

  return (
    <div style={{
      width: '100%',
      maxWidth: fullScreen ? '1020px' : '807px',
      margin: '0 auto',
      aspectRatio: fullScreen ? '4 / 3' : '3 / 2',
    }}>
      <Swiper
        modules={[Navigation, Pagination, A11y, Autoplay, EffectFade]}
        spaceBetween={50}
        loop={true}
        slidesPerView={1}
        lazy={true}
        pagination={{
          clickable: true,
          dynamicBullets: true,
        }}
        autoplay={{delay: 3000}}
        grabCursor={true}
        effect={'fade'}
        style={{width: '100%', height: '100%'}}
      >
        {images.map((image, index) => (
          <SwiperSlide key={index} style={slideStyle}>
            <Page
              image={image}
              fullScreen={fullScreen}
              isLCP={index === 0}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

WebviewCarousel.propTypes = {
  fullScreen: PropTypes.bool,
};

export default WebviewCarousel;
